import eventListener from "Packages/Carbon/Carbon.FileLoader/Resources/Private/Assets/EventListener";

function setIframeTargetForForm(form, target) {
    form.target = target;
    const iframe = document.createElement("iframe");
    iframe.setAttribute("name", target);
    iframe.className = "hidden";
    document.body.appendChild(iframe);
}

eventListener("mautic:init", () => {
    Alpine.magic("mauticPrefill", (el, { Alpine }) => {
        return (subject) => {
            if (typeof subject === "string") {
                subject = Alpine.evaluate(el, subject || "{}");
            }
            if (typeof subject !== "object") {
                return;
            }
            Object.entries(subject).forEach(([key, value]) => {
                const element = el.querySelector(`[name="mauticform[${key}]"]`);
                // Elemente is a single value field
                if (element) {
                    element.value = value;
                    return;
                }

                // We check for checkboxes, radio buttons and select-multiple
                const elements = [...el.querySelectorAll(`[name="mauticform[${key}][]"]`)];
                const valueAsArray = Array.isArray(value) ? value : [value];
                elements.forEach((element) => {
                    const type = element.type;
                    if (type === "checkbox" || type === "radio") {
                        element.checked = valueAsArray.includes(element.value);
                        return;
                    }
                    if (type === "select-multiple") {
                        [...element.querySelectorAll("option")].forEach((option) => {
                            option.selected = valueAsArray.includes(option.value);
                        });
                    }
                });
            });
        };
    });

    Alpine.data("mauticForm", ({ form, defaults }) => ({
        currentStep: 1,
        validationErrors: {},
        successMessage: null,
        errorMessage: null,
        sending: false,
        target: null,
        name: form.name,
        condition({ name, conditions }) {
            const value = this["__" + name];

            // No value set, so hide everything
            if (!value.length) {
                return false;
            }

            if (conditions.any) {
                return true;
            }

            if (conditions.expr === "in") {
                return conditions.values.some((item) => {
                    if (item == value) {
                        return true;
                    }
                    if (Array.isArray(value) && value.includes(item)) {
                        return true;
                    }
                });
            }

            return conditions.values.some((item) => {
                if (item != value) {
                    return true;
                }
                if (Array.isArray(value) && !value.includes(item)) {
                    return true;
                }
            });
        },
        field: (validation) => ({
            ":name"() {
                const element = this.$el;
                const name = element.getAttribute("x-model").substring(2);
                const type = element.type;
                const array = element.getAttribute("multiple") != null || type == "checkbox" || type == "radio";
                return `mauticform[${name}]${array ? "[]" : ""}`;
            },
            "x-on:invalid"() {
                const element = this.$el;
                const name = this.$el.getAttribute("x-model").substring(2);

                this.$nextTick(() => {
                    const validationErrorFromMautic = this.validationErrors[name];
                    if (validationErrorFromMautic) {
                        element.setCustomValidity(validationErrorFromMautic);
                        return;
                    }
                    if (element.required && validation) {
                        element.setCustomValidity(validation);
                    }
                });
            },
            "x-on:input"() {
                const element = this.$el;
                element.setCustomValidity("");
                element.reportValidity();
            },
        }),
        prevStep() {
            this.currentStep--;
        },
        nextStep() {
            const fieldset = this.$el.closest("fieldset");
            if (!fieldset) {
                return;
            }
            const valid = [...fieldset.querySelectorAll("input, select, textarea")].every((element) =>
                element.reportValidity(),
            );
            if (valid) {
                this.currentStep++;
            }
        },
        init() {
            // Set variables for x-model
            defaults.forEach(([name, value]) => {
                this["__" + name] = value;
            });

            // Set id for target
            this.target = this.$id("form-target");
            setIframeTargetForForm(this.$root, this.target);

            window.addEventListener("message", (event) => {
                if (event.origin !== form.origin) {
                    return;
                }
                const data = JSON.parse(event.data);
                this.errorMessage = data.errorMessage || null;
                if (data.formName !== form.alias) {
                    return;
                }
                this.sending = false;
                this.errors = {};

                if (!data.success) {
                    // normalize validationErrors
                    let firstErrorElement: null | HTMLElement = null;
                    let firstErrorPage: null | HTMLElement = null;
                    for (const key in data.validationErrors) {
                        let value = data.validationErrors[key];
                        if (typeof value !== "string") {
                            value = value.join(" ");
                        }
                        value = value.replaceAll("&quot;", '"');
                        data.validationErrors[key] = value;
                        // Report error to the elements
                        const elements = [...this.$root.querySelectorAll(`[x-model="__${key}"]`)];
                        elements.forEach((element) => {
                            element.setCustomValidity(value);
                            element.reportValidity();
                        });
                        if (!firstErrorElement && elements.length) {
                            firstErrorElement = elements[0];
                            firstErrorPage = elements[0].closest("[data-page]");
                        }
                    }
                    this.validationErrors = data.validationErrors;

                    if (firstErrorPage) {
                        const page = firstErrorPage.dataset.page;
                        if (page) {
                            this.currentStep = parseInt(page);
                        }
                    }
                    if (firstErrorElement) {
                        this.$nextTick(() => {
                            firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center" });
                        });
                    }

                    return;
                }
                if (data.redirect) {
                    window.location = data.redirect;
                    return;
                }

                this.successMessage = form.showMessage ? data.successMessage : null;
            });
        },
    }));
});
